goog.provide("shadow.js.shim.module$$mui$material$DialogTitle$default");
shadow.js.shim.module$$mui$material$DialogTitle$default = shadow.js.require(454, {})["default"];
